import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Select } from '@matyas/matyaskar-forked-react-ui/'


const mapper = (item) => ({
  value: item.uuid,
  label: item.name,
})

export default class EventLookup extends Component {
  static propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })).isRequired,
  }

  handleSearch = ({ value }) => {

      let typedInSearchText = this.refs.eventLookupInput.state.inputValue

      let result = this.props.events.find((item) => item.uuid === value);

      // now we handle the edge case that somebody typed in a result and hit the enter button.
      // when somebody hits the enter button the first selection of the selector gets selected (not necessarily the one
      // that matches the search text in the input field. So when the result label does not contain the characters of
      // the select input text we return the first result that matches input text. If no result matches the input text we
      // do nothing
      if (result) {
          let fallBackOptionMatch = false;
          if (!typedInSearchText) {
              // no search text available probably it was a direct mouse click
              location.href = result.url
          }
          else {
              //  some sort of search text is available
              //the search text may also match a fallback option we check for that case as well here
              this.props.fallbackEventNames.map((eventOption) =>{
                  if(eventOption.name.toLowerCase().indexOf(typedInSearchText) > -1){
                     if(eventOption.uuid === result.uuid){
                          fallBackOptionMatch = true;
                     }
                  }
              } );
              if (result.name.indexOf(typedInSearchText) > -1 || fallBackOptionMatch) {
                  // the result contains the characters of the typed in search text everything seems to be okay
                  location.href = result.url
              }
              else {
                  // the result name does not contain the typed in search text. We return the first result that we find that
                  // contains the typed in search text in its name
                  let firstMatchForSearchText = this.props.events.find(function (element) {
                    return element.name.toLowerCase().indexOf(typedInSearchText.toLowerCase()) > -1;
                  });
                  if(firstMatchForSearchText){
                    location.href = firstMatchForSearchText.url
                  }
                  else{
                          // the direct name search did not work let's go through the fallback options:
                          let fallbackMatchForSearchText = this.props.fallbackEventNames.find(function (element) {
                                return element.name.toLowerCase().indexOf(typedInSearchText.toLowerCase()) > -1;
                          });
                          if(fallbackMatchForSearchText){
                              location.href = fallbackMatchForSearchText.url;
                          }
                      }


              }

          }
    }



  }

  render () {
    const { events, fallbackEventNames } = this.props

    if (! events) {
      return null
    }

    return (
      <form className='form form--search'>
        <div className='form__row'>
          <div className='form__group'>
            <label className='form__label sr-only'>Search</label>
            <div className='form__control'>
              <Select
                name='value'
                updateValue={this.handleSearch}
                options={events.map(mapper)}
                fallbackOptions={fallbackEventNames.map(mapper)}
                placeholder="I'm attending"
                noOptionPlaceholder="Don't see your event? Contact us directly"
                ref='eventLookupInput'


              />
            </div>
          </div>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EventLookup.js